import { RumEvent } from '@datadog/browser-rum';

// The Datadog Browser RUM SDK's own resource-initiator instrumentation throws this
// internally on certain stack traces. It is not an app error and dominates the WebDS
// RUM error rate, so it should not flip the session into "Sessions with errors".
export const isDatadogSdkInternalError = (event: RumEvent): boolean =>
    event.type === 'error' &&
    event.error.source === 'console' &&
    (event.error.message?.includes('getInitiatorsChain') ?? false);
